import React, {useCallback, useContext, useEffect, useState} from 'react';

import './photos.css';

import {
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Divider, Paper,
    TextField,
    ToggleButton, ToggleButtonGroup
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useDropzone} from 'react-dropzone'
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {PAContext} from "../../../Services/PAContext";
import Photo from "../../../MasterEventObjects/Photo";
import {Stack} from "@mui/system";




function PhotosAddNew(){

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, authenticated } = dataArray;

    const [imagesToAdd, setImagesToAdd] = useState([]);
    useEffect(() => {
        console.log("imagesToAdd : ", imagesToAdd);
    }, [imagesToAdd]);
    const onDrop = useCallback(acceptedFiles => {
        const validTypes = ["image/jpeg", "image/png", "image/gif"];

        // We iterate and create the objects immediately without the FileReader bottleneck
        const newPhotos = acceptedFiles.map((file) => {
            // 1. Validation
            if (!file.type || !validTypes.includes(file.type)) {
                console.error(`Skipped "${file.name}" due to an invalid file type: ${file.type}`);
                return null;
            }

            // 2. Instantiate your Photo class
            const new_photo = new Photo();

            // 3. Identification & Metadata
            new_photo.event_id = PA_GlobalObject.Planning.id;
            new_photo.attendee_id = Account.id;

            new_photo.file_name = file.name;
            new_photo.file_type = file.type;
            new_photo.file_size = file.size;

            // 4. THE OPTIMIZATION
            // Store the raw File object for the compressor to use later
            new_photo.file = file;

            // Create a lightweight Pointer for the UI preview (uses near-zero RAM)
            new_photo.full_data = URL.createObjectURL(file);

            return new_photo;
        }).filter(p => p !== null); // Remove any skipped files

        // 5. Bulk update the state once to prevent multiple re-renders
        setImagesToAdd(prevImages => [...prevImages, ...newPhotos]);

    }, [PA_GlobalObject.Planning.id, Account.id]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxFiles: 30,
        accept: {
            "image/jpeg": [],
            "image/png": [],
            "image/gif": [],
        },
    });

    function handleCaptionChange(value, index) {
        setImagesToAdd(prev => {
            const updated = [...prev];
            updated[index].caption = value;
            return updated;
        });
    }

    // Function to toggle the public property of an image data object
    function togglePublic(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].private = !updatedImages[index].private;
            return updatedImages;
        });
    }

    // Function to toggle the sharable property of an image data object
    function toggleSharable(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].sharable = !updatedImages[index].sharable;

            // Ensure email list is initialized when sharable is enabled
            if (updatedImages[index].sharable && !updatedImages[index].share_with) {
                updatedImages[index].share_with = [];
            }

            return updatedImages;
        });
    }
    function handleEmailInputChange(event, index) {
        if (event.key === "Enter") {
            event.preventDefault();
            const newEmail = event.target.value.trim();

            if (newEmail && /\S+@\S+\.\S+/.test(newEmail)) { // Simple email validation
                setImagesToAdd(prevImages => {
                    const updatedImages = [...prevImages];
                    updatedImages[index].share_with.push(newEmail);
                    return updatedImages;
                });

                event.target.value = ""; // Clear input after adding
            }
        }
    }
    function removeEmail(imageIndex, emailIndex) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[imageIndex].share_with.splice(emailIndex, 1);
            return updatedImages;
        });
    }

    // Function to toggle the photo_album property of an image data object
    function togglePhotoAlbum(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].photo_album = !updatedImages[index].photo_album;
            return updatedImages;
        });
    }

    function removeImage(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages.splice(index, 1);
            return updatedImages;
        });
    }

    function handlePromptAddNewClose() {
        navigate('/Planner/Photos');
    }

    async function handlePhotosAddOK() {
        console.log("handlePhotosAddOK : ", authenticated);

        console.log("imagesToAdd : ", imagesToAdd);

        for (const photo of imagesToAdd) {

            // Request Signed URL from Server
            if (PA_GlobalObject.Planning.status !== 10){
                const _sendString = {
                    action: "E_requestPhotoUploadUrlForGCS",
                    photo: photo
                };
                sendSocketMessage(_sendString);

            }

            try {

                // Store photo for the actual PUT upload
                window.pendingUploads = window.pendingUploads || new Map();
                window.pendingUploads.set(photo.temp_id, photo);

            } catch (err) {
                console.error("Processing failed for photo:", photo.file_name, err);
            }
        }

        // Update Global State with ONLY the metadata and preview URL
        set_PA_GlobalObject((prev) => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                photos: [...(prev.Planning.photos || []), ...imagesToAdd],
            },
        }));

        navigate('/Planner/Photos');
    }

    return (

        <div className="photos-list-container" >

            {/* --- NEW PHOTOS UPLOAD HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)', // Indigo to Purple
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(99, 102, 241, 0.3)'
                        }}>
                            <i className="icon-plus" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{
                                fontWeight: 800,
                                color: '#1e293b',
                                fontSize: '1rem',
                                letterSpacing: -0.4,
                                lineHeight: 1.2
                            }}>
                                New Photos
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <i className="icon-camera" style={{ color: '#6366f1', fontSize: '10px' }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem' }}>
                                    Upload Memories
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Action Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                            variant="text"
                            size="small"
                            onClick={handlePromptAddNewClose}
                            sx={{
                                color: '#64748b',
                                fontWeight: 700,
                                fontSize: '0.75rem',
                                borderRadius: '10px',
                                textTransform: 'none',
                                '&:hover': { bgcolor: '#f1f5f9' }
                            }}
                        >
                            Cancel
                        </Button>

                        {imagesToAdd.length > 0 && (
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handlePhotosAddOK}
                                startIcon={<i className="icon-cloud-upload" style={{ fontSize: '14px' }} />}
                                sx={{
                                    bgcolor: '#4338ca',
                                    color: 'white',
                                    borderRadius: '10px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: '0.75rem',
                                    px: 2,
                                    boxShadow: '0 4px 12px rgba(67, 56, 202, 0.2)',
                                    '&:hover': { bgcolor: '#3730a3' }
                                }}
                            >
                                Add {imagesToAdd.length}
                            </Button>
                        )}
                    </Box>
                </Box>
            </Paper>


            {/* the items for adding photos */}
            <div className="photos-add-new-item-container">

                <Box
                    {...getRootProps()}
                    sx={{
                        // 1. The Container (Card-like & Inviting)
                        border: "2px dashed #e0e7ff", // Lavender dotted line
                        bgcolor: isDragActive ? "#eef2ff" : "#f8faff", // Change background on drag
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: "16px", // Softer corners
                        margin: '20px',
                        py: 5, // Extra vertical padding makes it feel significant
                        transition: 'all 0.2s ease', // Smooth transition on hover/drag

                        // 2. Interactive States
                        '&:hover': {
                            borderColor: '#6366f1', // Shift to Indigo on hover
                            bgcolor: '#eef2ff',
                            transform: 'scale(1.01)', // Very subtle scale effect
                        }
                    }}
                >
                    <input {...getInputProps()} />

                    {/* 3. The Central Icon (Indigo Images) */}
                    <i
                        className="icon-images"
                        style={{
                            fontSize: '38px',
                            color: '#6366f1', // Use the module color
                            marginBottom: '12px',
                            display: 'block'
                        }}
                    />

                    {/* 4. The Prominent Call to Action */}
                    <Typography sx={{
                        fontWeight: 700,
                        color: '#4338ca', // Darker Indigo for text
                        fontSize: '0.9rem',
                        mb: 0.5
                    }}>
                        {isDragActive ? "Drop them now!" : "Click or Drag photos here"}
                    </Typography>

                    {/* 5. The Help Subtitle */}
                    <Typography
                        variant="caption"
                        sx={{
                            color: '#94a3b8',
                            fontWeight: 500,
                            letterSpacing: '0.01em'
                        }}
                    >
                        Up to 30 photos (JPEG, PNG, GIF)
                    </Typography>
                </Box>

                {imagesToAdd && imagesToAdd.map((imageData, index) => {
                    const isAlbumActive = !!imageData.photo_album;
                    const isPrivate = !!imageData.private;
                    const isSharable = !!imageData.sharable;

                    return (
                        <Card
                            key={index}
                            sx={{
                                marginBottom: '28px',
                                borderRadius: '24px',
                                overflow: 'hidden',
                                border: isAlbumActive ? '2.5px solid #f09637' : '1px solid #e0e0e0',
                                boxShadow: isAlbumActive ? '0 12px 30px rgba(240, 150, 55, 0.2)' : '0 4px 12px rgba(0,0,0,0.05)',
                                transition: 'all 0.3s ease-in-out'
                            }}
                        >
                            {/* Photo Preview Area */}
                            <Box sx={{ position: 'relative', height: '220px' }}>
                                <CardMedia
                                    component="img"
                                    src={imageData.full_data}
                                    alt={`Image ${index + 1}`}
                                    sx={{ height: '100%', objectFit: 'cover' }}
                                />

                                {/* DELETE BUTTON Overlay */}
                                <IconButton
                                    onClick={() => removeImage(index)}
                                    sx={{
                                        position: 'absolute', top: 12, right: 12,
                                        bgcolor: 'rgba(255, 255, 255, 0.4)',
                                        backdropFilter: 'blur(4px)',
                                        color: '#ff4d4d',
                                        '&:hover': { bgcolor: '#ff4d4d', color: '#fff' }
                                    }}
                                >
                                    <i className="icon-trash" />
                                </IconButton>

                                {/* THE "IN SLIDESHOW" BUTTON Overlay */}
                                <Box sx={{ position: 'absolute', bottom: 16, left: 16, right: 16 }}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        onClick={() => togglePhotoAlbum(index)}
                                        startIcon={<i className={isAlbumActive ? "icon-star-filled" : "icon-star"} />}
                                        sx={{
                                            borderRadius: '14px',
                                            textTransform: 'none',
                                            fontWeight: '800',
                                            background: isAlbumActive
                                                ? 'linear-gradient(135deg, #f09637 0%, #ffc107 100%)'
                                                : 'rgba(255,255,255,0.95)',
                                            color: isAlbumActive ? '#fff' : '#2c3e50',
                                            boxShadow: isAlbumActive ? '0 4px 15px rgba(240, 150, 55, 0.4)' : 'none',
                                            '&:hover': { background: isAlbumActive ? '#e67e22' : '#fff' }
                                        }}
                                    >
                                        {isAlbumActive ? "LIVE IN SLIDESHOW!" : "Add to Cover Slideshow"}
                                    </Button>
                                </Box>
                            </Box>

                            <CardContent sx={{ pt: 3, px: 3 }}>
                                {/* Caption Field */}
                                <TextField
                                    fullWidth
                                    placeholder="Adventure caption... ⛰️"
                                    variant="standard"
                                    value={imageData.caption || ""}
                                    onChange={(e) => handleCaptionChange(e.target.value, index)}
                                    InputProps={{
                                        disableUnderline: true,
                                        sx: { fontSize: '18px', fontWeight: '700', mb: 2 }
                                    }}
                                />

                                <Stack spacing={3}>

                                    <Divider />

                                    {/* VISIBILITY SECTION (Now on two lines) */}
                                    <Box>
                                        <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                                            <i className={isPrivate ? "icon-lock" : "icon-users"}
                                               style={{ color: isPrivate ? '#e74c3c' : '#27ae60', fontSize: '18px' }} />
                                            <Typography variant="subtitle2" sx={{ fontWeight: '800', color: '#1a202c' }}>
                                                Who can see this photo?
                                            </Typography>
                                        </Box>

                                        <ToggleButtonGroup
                                            fullWidth
                                            size="small"
                                            value={isPrivate ? 'NO' : 'YES'}
                                            exclusive
                                            onChange={() => togglePublic(index)}
                                            sx={{
                                                height: '42px',
                                                borderRadius: '12px',
                                                '& .MuiToggleButton-root': {
                                                    textTransform: 'none',
                                                    fontWeight: '700',
                                                    border: '1px solid #e2e8f0',
                                                    color: '#718096'
                                                },
                                                '& .MuiToggleButton-root.Mui-selected': {
                                                    bgcolor: isPrivate ? '#ffeded' : '#eafaf1',
                                                    color: isPrivate ? '#e74c3c' : '#27ae60',
                                                    borderColor: isPrivate ? '#fab1a0' : '#82e0aa',
                                                    '&:hover': { bgcolor: isPrivate ? '#ffe0e0' : '#dcfce7' }
                                                }
                                            }}
                                        >
                                            <ToggleButton value="YES" sx={{ flex: 1 }}>
                                                Everyone (Group)
                                            </ToggleButton>
                                            <ToggleButton value="NO" sx={{ flex: 1 }}>
                                                Just Me (Private)
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                            {isPrivate ? "🔒 Hidden from other attendees." : "🌍 Visible to everyone in the trip."}
                                        </Typography>
                                    </Box>

                                    <Divider />

                                    {/* EXTERNAL SHARING SECTION */}
                                    <Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <i className="icon-share" style={{ color: '#428ce2' }} />
                                                <Typography variant="subtitle2" sx={{ fontWeight: '800' }}>
                                                    Public Magic Link
                                                </Typography>
                                            </Box>
                                            <Button
                                                size="small"
                                                variant={isSharable ? "contained" : "outlined"}
                                                onClick={() => toggleSharable(index)}
                                                sx={{
                                                    borderRadius: '20px',
                                                    textTransform: 'none',
                                                    fontWeight: 'bold',
                                                    bgcolor: isSharable ? '#428ce2' : 'transparent',
                                                    color: isSharable ? '#fff' : '#428ce2'
                                                }}
                                            >
                                                {isSharable ? "Link Enabled" : "Enable"}
                                            </Button>
                                        </Box>

                                        {isSharable && (
                                            <Box sx={{ mt: 2, p: 2, bgcolor: '#f0f8ff', borderRadius: '16px', border: '1px solid #428ce230' }}>
                                                <input
                                                    type="email"
                                                    placeholder="Add email + Enter ✉️"
                                                    onKeyPress={(event) => handleEmailInputChange(event, index)}
                                                    style={{
                                                        width: '100%',
                                                        padding: "10px 0",
                                                        border: "none",
                                                        borderBottom: "2px solid #428ce2",
                                                        background: "transparent",
                                                        outline: "none",
                                                        fontSize: '14px'
                                                    }}
                                                />
                                                {imageData.share_with?.length > 0 && (
                                                    <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                        {imageData.share_with.map((email, emailIndex) => (
                                                            <Chip
                                                                key={emailIndex}
                                                                label={email}
                                                                size="small"
                                                                onDelete={() => removeEmail(index, emailIndex)}
                                                                sx={{ bgcolor: '#fff', border: '1px solid #428ce230' }}
                                                            />
                                                        ))}
                                                    </Box>
                                                )}
                                            </Box>
                                        )}
                                        {!isSharable && (
                                            <Typography variant="caption" color="text.secondary">
                                                Generate a link to share with friends outside this trip.
                                            </Typography>
                                        )}
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    );
                })}
            </div>
        </div>

    )

}

export default PhotosAddNew;
